<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form @submit="login">
                  <h1>{{ $t('login') }}</h1>
                  <p class="text-muted">{{ $t('signIn') }}</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-envelope"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" class="form-control" :placeholder="this.$t('email')" autocomplete="email" v-model="username"/>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" class="form-control" :placeholder="this.$t('password')" autocomplete="current-password" v-model="password"/>
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button type="submit" variant="primary" class="px-4 bg-protokol-royal-purple protokol-royal-purple">{{ $t('login') }}</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button variant="link-" class="px-0 clr-protokol-royal-purple" :to="{path: '/user/forgotpassword'}">{{ $t('forgotPassword') }}?</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card no-body class="text-white bg-protokol-royal-purple py-5" style="width:100%" v-if="$env.get('CLUSTER_MODE') == 'shared'">
              <b-card-body class="text-center bg-protokol-royal-purple">
                <div>
                  <h2>{{ $t('signUp') }}</h2>
                  <p>{{ $t('signUpNow') }}</p>
                  <router-link to="/register">
                  <b-button variant="protokol" class="mt-3 bg-protokol-royal protokol-royal-purple" >{{ $t('registerNow') }}!</b-button>
                  </router-link>
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<style scoped>
.card .card-body {
  border: none
}
</style>

<script>
import Axios from 'axios';

export default {
  name: 'Login',

  data: () => {
    return {
      username: "",
      password: "",
      errMessage: ""
    }
  },
  methods: {
    clientFactory() {
      const http = Axios.create({
        baseURL: this.$env.get("API_HOST"),
        timeout: 10000,
        headers: {
          'X-Project-Uuid': localStorage.getItem("current_project_uuid")
        }
      });

      http.defaults.withCredentials = true

      return http
    },

    login(e) {
      e.preventDefault()
      let popup = this.$loadingPopup()

      let username = this.username
      let pass = this.password

      this.clientFactory().post("/v1/user/login", {
        username: username,
        password: pass
      }
      )
      .then((resp) => {
        this.$gtag.event('login', {user: resp.data})
        this.$store.commit('setUser', resp.data)

        if (this.$env.get('MODE') == "production") {

        this.$Tawk.onLoad = function(){
          let toHash = resp.data.email + "-" + this.$env.get("TAWK_SRC");

          this.$Tawk.setAttributes({
            name: resp.data.name,
            email: resp.data.email,
            hash: toHash // see more https://www.tawk.to/javascript-api/#securemode
            }, function(){});
         }
        }


        if (this.$route.query["_ref"] !== undefined) {
          window.location.href = this.$route.query["_ref"]
          return
        }

        this.$router.push("/")
      })
      .catch((err) => {
        if (err.response === undefined) {
          throw err
        }

        if (err.response.status == 409) {
          this.$bvModal.msgBoxConfirm(this.$t('confirmEmail')).then(resp => {
            if (resp) {
              this.$http.post("/v1/user/send/confirmation/email", {email: this.username}).then(() => {
                this.$bvModal.msgBoxOk(this.$t('emailSent'))
              }).catch(error => {
                if (error.response.status == 500) {
                  this.$serverErrorModal(error)
                  return
                }
              })
            }
          })

          return
        }

        // redirect to two-factor auth
        if (err.response.status == 308) {
          this.$router.push("/two-factor-auth")
        }

        if (err.response === undefined) {
          this.$bvModal.msgBoxOk(this.$t('lostConnection'))
        }

        this.$bvModal.msgBoxOk(err.response.data.message)
      })
      .finally(() => {
        popup.hide()
      })
    }
  },
  mounted() {
    this.clientFactory().get("/v1/user/claims")
    .then(() => {
      this.$router.push({path: "/?force=true"})
    })
    .catch((error) => {
      if (error.response === undefined) {
        throw error
      }

      if (error.response.status == 500) {
        this.$serverErrorModal(error)
        return
      }

      if (error.response.status != 401) {
        this.$bvModal.msgBoxOk(error.response.data.message)
      }

    })
  }
}
</script>
